import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { clientParCode } from "../actions/clientsActions";
import {
  commandesPardaterep,
  commandeFiltre,
} from "../actions/commandeActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faX } from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "../RepresDetail.css";

const RepresDetail = () => {
  const [date_d, setDateD] = useState(new Date());
  const [date_f, setDateF] = useState(new Date());
  const [wFilter, setWFiltre] = useState("T");
  const [rech, setRech] = useState("");
  const [tabRech, setTabRech] = useState([]);
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { code } = location.state;

  const chariot = useSelector((state) => state.chariot);
  const commL = useSelector((state) => state.commandesListeRep);
  const { commandes, loading } = commL;
  const cl = useSelector((state) => state.client);
  const { client } = cl;

  useEffect(() => {
    setTabRech([]);
    if (wFilter === "R") {
      dispatch(commandeFiltre("Remis"));
    } else if (wFilter === "L") {
      dispatch(commandeFiltre("Livre"));
    } else {
      if (rech === "") {
        dispatch(commandesPardaterep(date_d, date_f, code));
      }
      if (rech !== "") {
        const filtered = commandes.filter((comm) =>
          comm.nom_cli.toUpperCase().includes(rech.toUpperCase())
        );
        setTabRech(filtered);
      }
    }
  }, [date_d, date_f, wFilter, rech, code, dispatch]);

  const existLiv = () => {
    return commandes.some((cmd) => cmd.isLivree);
  };

  const existRemis = () => {
    return commandes.some((cmd) => cmd.cmd_remis);
  };

  const renderItem = (comm) => {
    return (
      <div className="commande-item-det" key={comm._id}>
        <div
          className="commande-content-det"
          style={{
            backgroundColor: comm.cod_rep === null ? "#f0f7f6" : "#f8ff94",
          }}
          onClick={() => navigate(`/CommandeDetails/${comm._id}`)}
        >
          <div>
            <h3 className="client-name-det">{comm.nom_cli}</h3>
          </div>
          <div className="commande-details-det">
            <span className="commande-date-det">
              {comm.date_livraison.substring(0, 10) +
                " " +
                comm.date_livraison.substring(11, 16)}
            </span>
            <span className="commande-montant-det">
              {comm.totalePrix.toFixed(3)}
            </span>
            <span className="commande-status-det">
              {comm.cmd_remis ? (
                <FontAwesomeIcon icon={faCheck} color="green" />
              ) : (
                <FontAwesomeIcon icon={faX} color="red" />
              )}
            </span>
            <span className="commande-status-det">
              {comm.isLivree ? (
                <FontAwesomeIcon icon={faCheck} color="green" />
              ) : (
                <FontAwesomeIcon icon={faX} color="red" />
              )}
            </span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="container-det">
      <div className="client-info-det">
        <div className="info-row-det">
          <span className="info-label-det">
            {client?.nivcli_cloud === "R"
              ? "Réprésentant"
              : client?.nivcli_cloud === "F"
              ? "Client"
              : "Administrateur"}
            :
          </span>
          <span className="info-value-det">{client?.nom_cli}</span>
        </div>
        <div className="info-row-det">
          <span className="info-label-det">Totale Commandes:</span>
          <span className="info-value-det">
            {commandes?.reduce((acc, i) => acc + i.totalePrix, 0)?.toFixed(3)}
          </span>
        </div>
        {commandes && (
          <div className="info-row-det">
            <span className="info-label-det">Nombre des Commandes:</span>
            <span className="info-value-det">{commandes?.length}</span>
          </div>
        )}
        <div className="info-group-det">
          <div className="info-row-det">
            <span className="info-label-det">Par Client:</span>
            <span className="info-value-det">
              {commandes?.filter((c) => c.cod_rep === null).length}
            </span>
          </div>
          <div className="info-row-det">
            <span className="info-label-det">Par Rep:</span>
            <span className="info-value-det">
              {commandes?.filter((c) => c.cod_rep !== null).length}
            </span>
          </div>
        </div>
        <div className="date-pickers-det">
          <div className="date-picker-group-det">
            <label>Date Déb:</label>
            <DatePicker
              selected={date_d}
              onChange={(date) => setDateD(date)}
              dateFormat="dd/MM/yyyy"
              className="date-input-det"
            />
          </div>
          <div className="date-picker-group-det">
            <label>Date Fin:</label>
            <DatePicker
              selected={date_f}
              onChange={(date) => setDateF(date)}
              dateFormat="dd/MM/yyyy"
              className="date-input-det"
            />
          </div>
        </div>
      </div>

      {loading && (
        <div className="loading-overlay-det">
          <div className="loading-text-det">Veuillez patienter...</div>
        </div>
      )}

      {commandes && (
        <div className="filter-options-det">
          <label>
            <input
              type="radio"
              value="R"
              checked={wFilter === "R"}
              onChange={() => setWFiltre("R")}
              disabled={!existRemis() || wFilter === "L"}
            />
            Remis
          </label>
          <label>
            <input
              type="radio"
              value="L"
              checked={wFilter === "L"}
              onChange={() => setWFiltre("L")}
              disabled={!existLiv() || wFilter === "R"}
            />
            Livree
          </label>
          <label>
            <input
              type="radio"
              value="T"
              checked={wFilter === "T"}
              onChange={() => setWFiltre("T")}
            />
            Tous
          </label>
        </div>
      )}

      <div className="commandes-container-det">
        <div className="search-bar-det">
          <input
            type="text"
            placeholder="Taper le nom Client...."
            value={rech}
            onChange={(e) => setRech(e.target.value)}
          />
        </div>
        <div className="commandes-header-det">
          <span className="header-date-det">Date Cmd</span>
          <span className="header-montant-det">Montant</span>
          <span className="header-status-det">Rem</span>
          <span className="header-status-det">Livr</span>
        </div>
        <div className="commandes-list-det">
          {commandes && client && rech === ""
            ? commandes.map((comm) => renderItem(comm))
            : tabRech.map((comm) => renderItem(comm))}
        </div>
      </div>
    </div>
  );
};

export default RepresDetail;
